import { Box, Button, Link, TextField } from '@mui/material'
import { FormEvent, FormEventHandler, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useApp } from '../../hooks/useApp'
import { useNewPassword } from '../../hooks/useNewPassword'
import { RegistrationData } from '../../types/auth'
import { CustomSwitch } from '../atoms/CustomSwitch'
import { PasswordField } from '../atoms/PasswordField'
import { CountrySelector } from './CountrySelector'
import { Safety } from '../../classes/Safety'
import { isValidEmail } from '../../utils/email'
export interface RegistrationFormProps {
  onSubmit: (data: RegistrationData) => void
}

export function RegistrationForm(props: RegistrationFormProps): React.ReactElement {

  const { t } = useTranslation()
  const app = useApp()
  const [agreed, setAgreed] = useState(false)
  const newPassword = useNewPassword()

  const onSubmit: FormEventHandler<HTMLFormElement> = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const target = e.target as typeof e.target & {
      email: { value: string }
      phone: { value: string }
      country: { value: string }
    }

    const data: RegistrationData = {
      email: target.email.value.trim(),
      phone: /* target.phone.value */ '',
      password: newPassword.password,
      password_again: newPassword.passwordAgain,
      country: 'FI', // target.country.value,
      language: Safety.get('language', 'en'),
      area: 'FI',
      currency: 'EUR',
      defaultGroup: t('Default group for {email}').replace('{email}', target.email.value.trim()),
      defaultLocation: t('Home')
    }

    // The password rule is checked in the fields themselves, before anything is sent.
    if (!newPassword.submit()) {
      return
    }

    if (!agreed) {
      app.addError(t('Please read and accept the End User Licence Agreement first.'))
    } else if (!isValidEmail(data.email)) {
      app.addError(t('BAD_EMAIL'))
    } else {
      props.onSubmit(data)
    }
  }

  return (
    <Box component="form" onSubmit={onSubmit}>
      <TextField
        data-cy="text-Register Email Address"
        margin="normal"
        fullWidth
        id="email"
        label={t('Email')}
        name="email"
        autoComplete="email"
        autoFocus
      />
      {
        false &&
        <TextField
          margin="normal"
          fullWidth
          id="phone"
          label={t('Phone')}
          name="phone"
          autoComplete="phone"
          autoFocus
        />
      }
      <PasswordField
        id="password"
        name="password"
        label={t('Password')}
        cy="Register Password"
        autoComplete="new-password"
        {...newPassword.passwordField}
      />
      <PasswordField
        id="password-again"
        name="password_again"
        label={t('Re-enter password')}
        cy="Register Re-enter Password"
        autoComplete="new-password"
        {...newPassword.passwordAgainField}
      />
      {false && <CountrySelector/>}
      <Box sx={{ mt: 2, color: 'white' }}>
        <CustomSwitch data-cy='switch-Register switch' checked={agreed} sx={{ mr: 2 }} onClick={() => setAgreed(!agreed)}/>
        <Link href="https://www.enion.fi/ehdot" target="_blank" sx={{ cursor: 'pointer' }}>
          <Trans>Accept End User Licence Agreement</Trans>
        </Link>
      </Box>
      <Button
        data-cy='button-Register'
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        <Trans>Register</Trans>
      </Button>
  </Box>
  )
}
